"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Quote = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "4 4 16 16"
}, props), _react.default.createElement("path", {
  d: "M19.18 5c.452 0 .82.364.82.813v3.888c0 1.903-.169 3.403-.507 4.503-.338 1.1-.963 2.085-1.876 2.959-.748.716-1.665 1.304-2.752 1.77a.823.823 0 01-1.068-.397l-.59-1.237a.81.81 0 01.406-1.091c.918-.402 1.604-.911 2.056-1.526.575-.78.878-1.815.91-3.11H14.19a.817.817 0 01-.82-.814V5.813c0-.449.367-.813.82-.813zm-9.128 0c.453 0 .82.364.82.813v3.888c0 1.918-.168 3.423-.506 4.514-.338 1.092-.967 2.074-1.887 2.948-.753.714-1.666 1.303-2.739 1.766a.826.826 0 01-1.072-.397L4.08 17.3a.81.81 0 01.407-1.091c.918-.402 1.604-.911 2.056-1.526.575-.78.878-1.815.91-3.11H5.064a.817.817 0 01-.82-.814V5.813c0-.449.367-.813.82-.813z",
  className: "fill"
}));

var _default = Quote;
exports.default = _default;